export default __webpack_public_path__ + "static/media/vg_2.46cdc25c.svg";